var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4697_8423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.98855 11.6082C2.77607 11.6215 2.5671 11.5454 2.40571 11.396C2.08742 11.0512 2.08742 10.4943 2.40571 10.1495L9.37525 2.64383C9.7063 2.31022 10.2258 2.32877 10.5355 2.68529C10.8157 3.00768 10.832 3.50321 10.5738 3.84616L3.56317 11.396C3.40387 11.5433 3.19825 11.6192 2.98855 11.6082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94961 11.6082C9.73426 11.6072 9.52787 11.5152 9.37496 11.3518L2.4054 3.84613C2.11052 3.47529 2.15061 2.9172 2.49496 2.59961C2.8023 2.31616 3.25557 2.31616 3.56289 2.59961L10.5735 10.1053C10.9045 10.439 10.9216 10.9984 10.6117 11.3549C10.5994 11.3691 10.5867 11.3828 10.5735 11.396C10.4018 11.5568 10.1759 11.6336 9.94961 11.6082Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4697_8423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhiteIcon);
export default __webpack_public_path__ + "static/media/closeWhiteIcon.fcfcd79c154e42155c08f642d7349af6.svg";
export { ForwardRef as ReactComponent };